<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você poderá lançar uma nova tarefa para as startups
              participantes do batch. A data de inicío e o deadline controlam o
              período em que a tarefa aceitará respostas.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8">
      <div class="row">
        <div class="col">
          <div class="card shadow mb-3">
            <div class="card-header bg-transparent">
              <h3 class="mb-0 vld-parent" ref="batch_container">
                <i class="fas fa-clipboard-list mr-1"></i>
                Tarefa do batch
                <span v-if="batch">
                  <span class="text-warning">{{ batch.name }}</span>
                  <router-link
                    :to="`/admin/batches/${batch.id}/acompanhamento`"
                  >
                    <i class="ml-2 fas fa-eye text-sm"></i>
                  </router-link>
                </span>
              </h3>
            </div>
            <div class="card-body vld-parent" ref="task_container">
              <div class="row">
                <div class="col-lg-6">
                  <base-input label="Título da tarefa">
                    <textarea
                      rows="1"
                      class="form-control form-control"
                      placeholder="Digite aqui..."
                      v-model="model.task.title"
                    >
                    </textarea>
                  </base-input>
                </div>
                <div class="col-6">
                  <label class="form-control-label">
                    Status da tarefa
                    <i
                      v-if="model.task.status"
                      class="fas fa-info-circle ml-1"
                      :title="getStatusDescription"
                    ></i>
                  </label>
                  <base-input addon-left-icon="fas fa-cogs">
                    <select class="form-control" v-model="model.task.status">
                      <option selected disabled value="">
                        Selecione o status da tarefa
                      </option>
                      <option
                        v-for="status in taskStatus"
                        :key="status.key"
                        :value="status.key"
                      >
                        {{ status.value }}
                      </option>
                    </select>
                  </base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <label class="form-control-label">
                    Família (opcional)
                    <i
                      class="fas fa-info-circle ml-1"
                      title="A tag famíla permite que as tarefas sejam agrupadas para facilitar a posterior visualização de tarefas de uma mesma categoria."
                    ></i>
                  </label>
                  <base-input
                    placeholder="Família da tarefa"
                    input-classes="form-control"
                    addon-left-icon="fas fa-layer-group"
                    v-model="model.task.family"
                  />
                </div>
                <div class="col-lg-6 text-center text-lg-left">
                  <base-input label="Resposta numérica?">
                    <br />
                    <base-switch
                      v-bind:value="model.task.is_number"
                      @input="isNumberChangeHandler($event)"
                    />
                  </base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group has-label">
                    <label class="form-control-label">Data de início</label>
                    <base-input
                      type="date"
                      placeholder="Data de início"
                      input-classes="form-control"
                      addon-left-icon="ni ni-calendar-grid-58"
                      v-model="model.task.start_date"
                    />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group has-label">
                    <label class="form-control-label"
                      >Deadline (opcional)</label
                    >
                    <base-input
                      type="date"
                      placeholder="Deadline"
                      input-classes="form-control"
                      addon-left-icon="ni ni-calendar-grid-58"
                      v-model="model.task.deadline"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 tf-container-edditable">
                  <base-input label="Descrição da tarefa (opicional)">
                    <quill-editor
                      v-model="model.task.description"
                      :options="editorEdittableDescription"
                    >
                    </quill-editor>
                  </base-input>
                </div>
                <div class="col-lg-6 tf-container-edditable">
                  <base-input label="Instruções para a submissão">
                    <quill-editor
                      v-model="model.task.instructions"
                      :options="editorEdittableInstructions"
                    >
                    </quill-editor>
                  </base-input>
                </div>
              </div>
              <div class="col-12 text-center" v-if="error">
                <base-alert type="danger">{{ error }}</base-alert>
              </div>
              <base-button
                type="primary"
                @click="handleSubmitTask()"
                class="mt-1 float-right"
                :disabled="!isValidModel"
              >
                Criar tarefa
              </base-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

import api from "@/services/api";

export default {
  name: "tasks_list",
  components: {
    quillEditor,
  },
  data() {
    return {
      model: {
        task: {
          title: "",
          status: "",
          family: "",
          start_date: "",
          deadline: "",
          description: "",
          instructions: "",
          is_number: false,
        },
      },
      taskStatus: [
        {
          key: "visible",
          value: "Visível",
          description:
            "Uma tarefa visível pode ser vista pelas startups do batch, que podem realizar a submissão de suas respostas caso a data atual respeite a data de início e o deadline da tarefa.",
        },
        {
          key: "hidden",
          value: "Invisível",
          description:
            "Uma tarefa invisível fica oculta para todas as startups, não aparecendo nem mesmo em seu histórico.",
        },
      ],
      editorEdittableDescription: {
        placeholder:
          "Descreva a tarefa (lembre-se, se necessário, você pode linkar arquivos pelo editor)",
      },
      editorEdittableInstructions: {
        placeholder:
          "Digite aqui os detalhes sobre o que a startup deve enviar  (lembre-se, se necessário, você pode linkar arquivos pelo editor)",
      },
      batch: "",
      error: "",
    };
  },
  async mounted() {
    const loaderBatch = this.$loading.show({
      container: this.$refs.batch_container,
      width: 90,
      height: 90,
    });
    await this.loadBatch();
    loaderBatch.hide();
  },
  methods: {
    async loadBatch() {
      try {
        const { data: batch } = await api.get(
          `/batches/${this.$route.params.idBatch}`
        );
        if (!batch) {
          this.$toasted.error("Batch não encontrado");
          this.$router.push("/admin/batches");
          return;
        }
        this.batch = batch;
      } catch (e) {
        this.$toasted.error("Error ao carregar informações do batch");
        this.$router.push("/admin/batches");
      }
    },
    async handleSubmitTask() {
      this.error = "";
      const loader = this.$loading.show({
        container: this.$refs.task_container,
        width: 90,
        height: 90,
      });
      try {
        const task = this.model.task;
        await api.post(`/batches/${this.$route.params.idBatch}/tasks`, task);
        this.$toasted.show("Tarefa cadastrada com sucesso");
        this.$router.push(
          `/admin/batches/${this.$route.params.idBatch}/acompanhamento`
        );
      } catch (e) {
        this.error = "Ocorreu um erro ao criar a tarefa. Tente novamente.";
        this.$toasted.error(this.error);
      }
      loader.hide();
    },
    isNumberChangeHandler(event) {
      if (typeof event === "boolean") this.model.task.is_number = event;
    },
  },
  computed: {
    getStatusDescription() {
      const selectedStatus = this.taskStatus.find(
        (status) => status.key === this.model.task.status
      );
      return selectedStatus ? selectedStatus.description : "";
    },
    isValidModel() {
      const requiredFields = ["title", "status", "start_date", "instructions"];
      for (const key of requiredFields) {
        if (this.model.task[key] === "") return false;
      }
      return true;
    },
  },
};
</script>
<style>
.tf-container-edditable .quill-editor .ql-container,
.tf-container-edditable .quill-editor .ql-container .ql-editor {
  min-height: 11rem;
  width: 100%;
}

p > strong {
  font-weight: bold !important;
}
</style>
